import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  Modal, 
  TextField, 
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../components/buttons/Button';

import { 
  CreateCampaignBIZfusionWyzia 
} from '../../../../../redux/actions/business/fusion/wyzia/campaignsActions';

import global from "../../../../../global.scss";

const Data = {
  Name: "",
};

const CampaignsModal = ({
  open, 
  setOpen, 
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(1);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(1);
  }

  useEffect(() => {
    try {
      if(open){
        if(update.defaultMode === 1){
          // mode = 1 - create campaign
          setMode(1);
        }else{
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);


  // --------------- handle change ----------------
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if(mode === 1){
      // create campaign
      let obj = {};
      if(process.env.REACT_APP_ENV === "production"){
        obj = {
          "name": formData.Name,
          "country": "US",
          "urls": {
            "listenerUrl": "https://webhook.lusidpay.com/common/webhook/v1/wyzia",
            "successUrl": "https://webhook.lusidpay.com/common/webhook/v1/wyzia",
            "failureUrl": "https://webhook.lusidpay.com/common/webhook/v1/wyzia"
          }
        };
      } else {
        obj = {
          "name": formData.Name,
          "country": "US",
          "urls": {
            "listenerUrl": "https://alpha-webhook.lusid.ai/common/webhook/v1/wyzia",
            "successUrl": "https://alpha-webhook.lusid.ai/common/webhook/v1/wyzia",
            "failureUrl": "https://alpha-webhook.lusid.ai/common/webhook/v1/wyzia"
          }
        };
      }

      //  "urls": {
      //     "listenerUrl": "https://alpha-webhook.lusid.ai/common/webhook/v1/wyzia",
      //     "successUrl": "https://alpha-webhook.lusid.ai/common/webhook/v1/wyzia",
      //     "failureUrl": "https://alpha-webhook.lusid.ai/common/webhook/v1/wyzia"
      //   }

      dispatch(CreateCampaignBIZfusionWyzia(obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        })
      })
    }else{
      toast.error("Invalid modal");
      handleClose();
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"}
            sx={{ padding: "15px"}}>
            <Typography variant='h6' sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>
            <Box 
              className="flexCenterSBRow"
              gap={"15px"}
              mb={"15px"}>
              <TextField 
                label="Campaign Name"
                fullWidth
                name="Name"
                value={formData.Name}
                onChange={handleChange}
                inputProps={{ maxLength: 128 }}
                />
            </Box>
          </Box>
          <Divider
           sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='text'
              onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton 
              variant='contained'
              loading={loading}
              disabled={!(formData.Name !== "")}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default CampaignsModal;